// extracted by mini-css-extract-plugin
module.exports = {"status":"Status-module--status--2FPMg","warning":"Status-module--warning--r_nOi","error":"Status-module--error--3MOAG"};